export default "__VITE_ASSET__BoIiokjz__"